import { FormikProvider, useFormik } from 'formik';
import * as yup from 'yup';
import {
  useIssuerAddPortfolioMutation,
  useIssuerUpdatePortfolioMutation,
} from '@/modules/issuer-dashboard/queries/portfolios.tsx';
import { BaseModalProps, Button, ModalContentWrapper, TextInputField } from 'ui';
import { CreatePortfolioRequest, PortfolioModel } from 'api';

const validationSchema = yup.object<CreatePortfolioRequest>({
  name: yup
    .string()
    .trim()
    .required('Portfolio name is required')
    .min(1, 'Portfolio name is too short'),
  // register_class_ids: yup.array().min(1, 'Class is required').required('Class is required'),
});

export interface IssuerAddUpdatePortfolioModalProps extends BaseModalProps {
  item?: PortfolioModel;
  onlyClasses?: boolean;
}

export const IssuerAddUpdatePortfolioModal = ({
  open,
  onClose,
  item,
  onlyClasses = false,
}: IssuerAddUpdatePortfolioModalProps) => {
  const formik = useFormik<CreatePortfolioRequest>({
    validationSchema,
    initialValues: {
      name: item?.name || '',
      // register_class_ids: item?.portfolio_classes?.map(item => item.id) || [],
    },
    validateOnBlur: false,
    validateOnChange: false,
    validateOnMount: false,
    onSubmit: values => {
      if (item) {
        mutateAsyncUpdate({
          ...values,
          id: item.id,
        });
      } else {
        mutateAsyncAdd(values);
      }
    },
  });

  const { mutateAsync: mutateAsyncAdd, isLoading: isLoadingAdd } = useIssuerAddPortfolioMutation({
    setErrors: formik.setErrors,
    onSuccess: onClose,
  });
  const { mutateAsync: mutateAsyncUpdate, isLoading: isLoadingUpdate } =
    useIssuerUpdatePortfolioMutation({
      setErrors: formik.setErrors,
      onSuccess: onClose,
    });

  // const handleToggleClass = useCallback(
  //   (id: number, checked: boolean) => {
  //     formik.setFieldValue(
  //       'classes',
  //       !checked ? [...formik.values.classes, id] : formik.values.classes.filter(idx => idx !== id),
  //     );
  //   },
  //   [formik],
  // );

  // const handleChangeRegisterClass = (
  //   value: SelectPaginateOption<number>[] | SelectPaginateOption<number>,
  // ) => {
  //   const register_class_ids = Array.isArray(value) ? value.map(v => v.value) : [value.value];
  //
  //   formik.setFieldValue('register_class_ids', register_class_ids);
  //   formik.setFieldError('register_class_ids', '');
  // };

  // const handleChangeBank = (item: SelectPaginateOption<RegisterBankExtended> | null) => {
  //   formik.setFieldValue('bank_id', item?.value.id);
  //   formik.setFieldError('bank_id', '');
  // };

  return (
    <ModalContentWrapper
      onClose={onClose}
      open={open}
      title={item ? `Update ${onlyClasses ? 'classes' : 'portfolio'}` : 'New portfolio'}
      classes={{ children: 'p-0' }}
    >
      <FormikProvider value={formik}>
        <div className="p-3 sm:p-6 flex flex-col w-full gap-6">
          {onlyClasses === false && (
            <TextInputField
              name="name"
              label="Portfolio name"
              placeholder="Enter portfolio name..."
            />
          )}
          {/* <RegisterClassesSelectPaginate */}
          {/*   isMulti={true} */}
          {/*   showAddNewItem={true} */}
          {/*   label="CLASSES" */}
          {/*   onChange={handleChangeRegisterClass} */}
          {/*   value={formik.values.register_class_ids} */}
          {/*   error={ */}
          {/*     typeof formik?.errors?.register_class_ids === 'object' */}
          {/*       ? formik.errors.register_class_ids[0] */}
          {/*       : formik.errors.register_class_ids */}
          {/*   } */}
          {/* /> */}
          {/* <RegisterBanksSelect */}
          {/*   onChange={handleChangeBank} */}
          {/*   value={formik.values.bank_id} */}
          {/*   label="Bank account" */}
          {/*   clearable={true} */}
          {/*   error={formik.errors.bank_id} */}
          {/*   bankType={BankTypeEnum.Portfolio} */}
          {/* /> */}
          {/* <div className="flex flex-col w-full gap-4"> */}
          {/*   <p className="font-medium">Select classes</p> */}
          {/*   <SearchField placeholder="Search" /> */}
          {/*   <div className="min-h-[400px] gap-4 flex flex-col w-full"> */}
          {/*     {mockClasses.map(({ id, name, availableCash }) => { */}
          {/*       const isChecked = formik.values.classes.includes(id); */}
          {/*       return ( */}
          {/*         <div key={id} className="flex gap-4"> */}
          {/*           <CustomCheckbox */}
          {/*             checked={formik.values.classes.includes(id)} */}
          {/*             className={classNames( */}
          {/*               '[&_.ant-checkbox-inner]:w-5', */}
          {/*               '[&_.ant-checkbox-inner]:h-5', */}
          {/*               '[&_.ant-checkbox:hover>.ant-checkbox-inner]:!border-gray-900', */}
          {/*               '[&_.ant-checkbox-inner]:!rounded-sm', */}
          {/*               '[&_span.ant-checkbox-checked>.ant-checkbox-inner]:bg-gray-900', */}
          {/*               '[&_span.ant-checkbox-checked>.ant-checkbox-inner]:border-gray-900', */}
          {/*               '[&_span.ant-checkbox-checked:hover>.ant-checkbox-inner]:!bg-gray-900', */}
          {/*               '[&_span.ant-checkbox-checked:hover>.ant-checkbox-inner]:!border-gray-900', */}
          {/*             )} */}
          {/*             onChange={handleToggleClass.bind(null, id, isChecked)} */}
          {/*           /> */}
          {/*           <div */}
          {/*             className="cursor-pointer truncate text-sm w-[290px]" */}
          {/*             onClick={handleToggleClass.bind(null, id, isChecked)} */}
          {/*           > */}
          {/*             {name} */}
          {/*           </div> */}
          {/*           <div className="flex-1 text-xs text-gray-500"> */}
          {/*             Available cash: {goodFormatUSDCurrencyLowPrecision(availableCash)} */}
          {/*           </div> */}
          {/*         </div> */}
          {/*       ); */}
          {/*     })} */}
          {/*   </div> */}
          {/* </div> */}
        </div>
        <div className="mt-4 p-3 !pb-0 sm:p-6">
          <Button
            type="submit"
            onClick={formik.handleSubmit}
            loading={isLoadingAdd || isLoadingUpdate}
          >
            {item ? `Update ${onlyClasses ? 'classes' : 'portfolio'}` : 'Add new portfolio'}
          </Button>
        </div>
      </FormikProvider>
    </ModalContentWrapper>
  );
};
